import { Locality } from "./localities.model";
import { Society } from "./society.model";

export class Site {
    id: number;
	designation: string;
	abbreviation: string;
	sale: boolean;
	expedition: boolean;
	locality: Locality;
	society: Society;

    constructor() {
		this.locality = new Locality();
		this.society = new Society();
    }
}


export class SiteForm {
    id: number;
	designation: string;
	abbreviation: string;
	sale: boolean;
	expedition: boolean;
	locality: Locality;
	society: number;

    constructor() {
		this.locality = new Locality();
    }
}